import React from "react";
import "./NotFoundContent.scss";
import { ReactComponent as NotFoundSVG } from "../../../assets/images/notfound.svg";
import { Link } from "react-router-dom";
import Button from "../../../components/Button";

const NotFoundContent = () => {
  return (
    <main className="not-found-page">
      <section className="not-found-content">
        <NotFoundSVG />
        <h3>404: Page not found</h3>
        <p>
          The page you’re looking for has even been moved, or is no longer
          available.
        </p>
        <Link to="/">
          <Button type="button" size="size-lg" colorTheme="has-primary-theme">
            Back to Home
          </Button>
        </Link>
      </section>
    </main>
  );
};

export default NotFoundContent;
